import address from './address';
import email from './email';
import page from './page';
import phone from './phone';
export default {
  page,
  address,
  email,
  phone,
};
